import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const init = () => {
  const triggers = document.querySelectorAll(".section-banner");
  if (!triggers) return;

  triggers.forEach((trigger) => {
    const banner = trigger.querySelector("img");
    if (!banner) return;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: trigger,
        start: "top center",
        end: "bottom center",
        pin: false,
        // markers: true,
        scrub: 1,
      },
    });

    tl.from(banner, {
      duration: 4,
      scale: 1.2,
      ease: "power2.out",
    });
  });
};
